import { AlertTriangle } from "lucide-react";
import ConfirmDialog from "@/components/ConfirmDialog";
import { inr } from "@/lib/format";

function Line({ l, v, testid, strong }) {
  return (
    <div className="flex justify-between gap-4 py-1.5 border-b border-slate-100 last:border-0 text-sm">
      <span className="text-slate-600">{l}</span>
      <span className={`money ${strong ? "font-bold text-blue-800" : "font-semibold"}`} data-testid={testid}>{v}</span>
    </div>
  );
}

export default function PayrollConfirm({ check, onClose, onConfirm, busy }) {
  const problems = check ? [...check.errors, ...check.ledger_issues] : [];
  const blocked = problems.length > 0;
  return (
    <ConfirmDialog open={!!check} onOpenChange={(o) => !o && onClose()} busy={busy} testid="payroll-confirm"
      title={blocked ? "Payroll cannot be finalized yet" : `Finalize payroll for ${check?.month_label}?`}
      confirmText={blocked ? "Close" : "Confirm & Finalize"} onConfirm={blocked ? onClose : onConfirm}
      description={blocked ? "Fix the items below, then try again. Nothing has been saved." : "Finalized payroll is locked. Only an administrator can reopen it."}>
      {check && (blocked ? (
        <div className="max-h-64 overflow-auto rounded-lg border border-red-200 bg-red-50 p-3 space-y-1" data-testid="payroll-confirm-problems">
          {problems.map((p) => <div key={p} className="text-xs text-red-800 flex gap-1.5"><AlertTriangle className="h-3.5 w-3.5 shrink-0 mt-0.5" />{p}</div>)}
        </div>
      ) : (
        <div className="rounded-lg border border-slate-200 px-4 py-2" data-testid="payroll-confirm-summary">
          <Line l="Payroll month" v={check.month_label} testid="confirm-month" />
          <Line l="Calculation method" v={check.method === "day" ? "Day-wise (salary ÷ 30)" : "Hour-wise (salary ÷ 30 ÷ shift hours)"} testid="confirm-method" />
          {check.method === "hour" && <Line l="Standard working hours / day" v={`${check.shift_hours} hours`} testid="confirm-shift" />}
          <Line l="Total employees" v={check.employees} testid="confirm-employees" />
          <Line l="Total earned salary" v={inr(check.totals.earned)} testid="confirm-earned" />
          <Line l="Total deductions" v={inr(check.totals.deduction)} testid="confirm-deduction" />
          <Line l="Total final payable salary" v={inr(check.totals.final)} testid="confirm-final" strong />
          {check.ledger_posts > 0 && <div className="text-xs text-slate-500 pt-2" data-testid="confirm-ledger-note">{check.ledger_posts} deduction{check.ledger_posts > 1 ? "s" : ""} will also be recorded in the employees' advance ledgers.</div>}
        </div>
      ))}
    </ConfirmDialog>
  );
}
